/*
 * Jira Ticket:
 * Updated Date: Mon, 20th Apr 2020, 18:01:49 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';
import uploadFile from './UPLOAD_FILE';

export const UpdateTowerTypeMutation = gql`
  mutation UpdateTowerType(
    $id: ID!
    $name: String!
    $qualificationIds: CommaSeparatedIntegerList!
    $status: TowerTypeStatus!
    $questions: [TowerTypeQuestionInput!]!
  ) {
    data: updateTowerType(
      id: $id
      name: $name
      qualificationIds: $qualificationIds
      status: $status
      questions: $questions
    ) {
      id
      name
      questionCount
      questions {
        id
        question
        image {
          id
          url
        }
      }
      qualificationIds
      updatedAt
      status
    }
  }
`;

export default async ({ client, params }) => {
  try {
    if (params.data.questions) {
      const uploadRequest = await uploadFile({
        client,
        questions: params.data.questions,
      });
      const questionsToSend = Array.from(params.data.questions);
      // if we had files to update
      if (uploadRequest) {
        let uploadRequestIndex = 0; // use this to go through the uploadRequest array
        for (let i = 0; i < questionsToSend.length; i++) {
          let question = questionsToSend[i];
          if (question.image.hasOwnProperty('rawFile')) {
            questionsToSend[i].imageId =
              uploadRequest.data.data.files[uploadRequestIndex].id;
            uploadRequestIndex += 1;
          } else {
            questionsToSend[i].imageId = questionsToSend[i].image.id;
          }
        }
      } else {
        // if we don't have updated images, make sure to set up the array anyway
        questionsToSend.forEach(
          towerTypeQuestion =>
            (towerTypeQuestion.imageId = towerTypeQuestion.image.id)
        );
      }
      params.data.questions = questionsToSend.map(towerTypeQuestion => {
        return (({ id = undefined, question, imageId }) => ({
          id,
          question,
          imageId,
        }))(towerTypeQuestion);
      });
    }
    if (!params.data.qualificationIds) params.data.qualificationIds = '';
    return client.mutate({
      mutation: UpdateTowerTypeMutation,
      variables: {
        ...params.data,
      },
    });
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};
